import crud from "./_crud";
import { callApi } from "utils/api";
import { showErrorMessage, showSuccessMessage } from "utils/messages";

const entity = 'route_setup';
const entityMsg = 'route_setup';

let customActions = {}

const actions = { ...crud('route_setup', 'el viaje', 'los viajes'), ...customActions };

const updateAddFile = (item, options) => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/route_setup/${item.id}/update_add_file`, {
         method: 'PATCH',
         json: false,
         headers: {
            Authorization: state.app.user.token
         },
         body: {
            file: item.files,
            expense_id: item.expense_id,
            item: JSON.stringify({ id: item.id, expenses_detail: item.expenses_detail })
         },
      });

      dispatch(actions.get(item.id))
      if(res.status == 200) {
         showSuccessMessage(`Se subió el comprobante correctamente.`)
      } else {
         showErrorMessage(`Error al subir el comprobante.`)
      }
      return dispatch({
         type: `UPLOAD_${entity.toUpperCase()}_EXPENSE_TICKET`,
         response: res,
         payload: item.id,
       });
   };
};

const deleteFile = (route_id, filename) => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/route_setup/${route_id}/file/${filename}`, {
         method: 'DELETE',
         json: false,
         headers: {
            Authorization: state.app.user.token
         },
      });

      dispatch(actions.get(route_id))
   };
};

const getExpensesDashboard = (options) => {
   return async (dispatch, getState) => {
     const state = getState()
 
     const res = await callApi(`/route_setup/utils/load_dashboard_expenses`, {
       method: 'GET',
       headers: {
         Authorization: state.app.user.token,
       },
     })
     return res.body
   }
 }

 const getAllRoutesBetweenDates = (initial_date, final_date) => {
   return async (dispatch, getState) => {
     const state = getState()
 
     const res = await callApi(`/route_setup/get_all_routes_between_dates`, {
       method: 'GET',
       headers: {
         Authorization: state.app.user.token,
       },
       params: {from: initial_date, to: final_date}
     })

     return res.body
   }
 }

 const getExpenses = () => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/expense`, {
         method: 'GET',
         headers: {
            Authorization: state.app.user.token
         },
      })

      return res.body
   }
 }

 const updateExpensesDetail = (route_id, expenses_detail) => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/route_setup/${route_id}/update_expenses_detail`, {
         method: 'PATCH',
         headers: {
            Authorization: state.app.user.token
         },
         body: JSON.stringify({ expenses_detail })
      })

      return res;
   }
 }

 const getUnits = () => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/unit`, {
         method: 'GET',
         headers: {
            Authorization: state.app.user.token
         },
      })

      return res.body
   }
}

const getTrailers = () => {
   return async (dispatch, getState) => {
      const state = getState();

      const res = await callApi(`/trailer`, {
         method: 'GET',
         headers: {
            Authorization: state.app.user.token
         },
      })

      return res.body
   }

}


export default { ...actions, updateAddFile, deleteFile, getExpensesDashboard, getAllRoutesBetweenDates, getExpenses, updateExpensesDetail, getUnits, getTrailers }